<template lang="html">
  <section class="text-legal pad-sec" v-html="$t('politica_cookies')">
  </section>
</template>

<script lang="js">
export default {
  name: 'politica-cookies'
}
</script>

<style scoped>
ul li {
  list-style: disc;
  margin-left: 20px;
}

b {
  font-weight: bold;
}

li.no-disc {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/views/politica-cookies.vue